import { map, Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { ApiResponse, TripPackage, TripPackageRequest } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class TripPackagesService {
  private apiService: ApiService = inject(ApiService);

  /**
   * Get a trip package by ID
   * @param id Trip package ID
   * @returns Trip package
   */
  getTripPackage(id: number): Observable<TripPackage> {
    return this.apiService
      .get<ApiResponse<TripPackage>>(`busticket_packages/${id}`)
      .pipe(map((response) => response.data));
  }

  /**
   * Get all trip packages for the current user
   * @returns All trip packages for the current user
   */
  getCurrentUserTripPackages(): Observable<TripPackage[]> {
    return this.apiService.get<ApiResponse<TripPackage[]>>('busticket_packages').pipe(map((response) => response.data));
  }

  /**
   * Get all trip packages
   * @returns All trip packages
   */
  getTripPackages(): Observable<TripPackage[]> {
    return this.apiService.get<ApiResponse<TripPackage[]>>('trip_packages').pipe(map((response) => response.data));
  }

  /**
   * Create a trip package
   * @param tripPackageRequest Trip package request
   * @returns Created trip package
   */
  createTripPackage(tripPackageRequest: TripPackageRequest): Observable<TripPackage> {
    return this.apiService.post<TripPackageRequest>('busticket_packages', tripPackageRequest);
  }
}
